import { Typography } from '@mui/material';
import { Grid, GridSize, GridSpacing, ResponsiveStyleValue, Stack } from '@mui/system';
import { useTranslation } from 'react-i18next';

import { Dimens } from '~themes';

import TwoLineData from './interfaces/twoLineData';
import TwoLineItem from './TwoLineItem';

interface TwoLineGridProps {
	twoLineItems: TwoLineData[];
	showError?: boolean;
	isLoading?: boolean;
	colSize?: ResponsiveStyleValue<GridSize>;
	rowSpacing?: ResponsiveStyleValue<GridSpacing>;
	columnSpacing?: ResponsiveStyleValue<GridSpacing>;
}

const TwoLineGrid = ({
	twoLineItems,
	isLoading = false,
	showError = false,
	colSize = { xs: 12, sm: 6 },
	rowSpacing = Dimens.spacingLg,
	columnSpacing = Dimens.spacing4xl,
}: TwoLineGridProps) => {
	const { t } = useTranslation();
	return (
		<Grid container rowSpacing={rowSpacing} columnSpacing={columnSpacing}>
			{showError ?
				<Stack spacing={Dimens.spacingLg} alignItems='flex-start'>
					<Typography variant='labelSm'>{t('failedToLoadData', { ns: 'errors' })}</Typography>
					<Typography variant='paragraphSm' color='text.secondary'>
						{t('failedToLoadDataDescription', { ns: 'errors' })}
					</Typography>
				</Stack>
			:	<>
					{twoLineItems.map(
						(item, _) =>
							!item.isHidden && (
								// Shouldn't use index as key. But primary is the most "unique" value we have at this moment.
								// Might need to have a key value in the two line item props.
								<Grid key={item.primary} size={colSize}>
									<TwoLineItem
										isLoading={isLoading}
										primary={item.primary}
										secondary={item.secondary}
										secondarySize={item.secondarySize}
										icon={item.icon}
										framedIconVariant={item.framedIconVariant}
										link={item.link}
										linkTarget={item.linkTarget}
										tooltipText={item.tooltipText}
									/>
								</Grid>
							)
					)}
				</>
			}
		</Grid>
	);
};

export default TwoLineGrid;
